import ReactDOM from 'react-dom';
import { FC, ReactNode, useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai';

import { closeModal } from './model';
import { useAppDispatch } from '@shared/model';
import { wrapperStyle, modalStyle, headerStyle, titleStyle } from './Modal.tailwind';

interface PropsType {
  title: string;
  children: ReactNode;
}

const Modal: FC<PropsType> = ({ title, children }) => {
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(closeModal());
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return ReactDOM.createPortal(
    <div className={wrapperStyle}>
      <div className={modalStyle} data-id="div-Modal">
        <div className={headerStyle}>
          <h3 className={titleStyle}>{title}</h3>
          <button onClick={handleClose} data-id="button-Close">
            <AiOutlineClose className="text-xl" />
          </button>
        </div>

        {children}
      </div>
    </div>,
    document.getElementById('portal')!
  );
};

export default Modal;
